export default function initBrandsFilter() {
    const activeClass = "active";
    const filterElement = $(".js-brands");
    const showAll = filterElement.find(".js-show-all").attr("href");
    var openers = filterElement.find(".brands-alphabet__item a");
    var contents = filterElement.find(".brands-item");

    openers.each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            var currentOpener = $(this);

            openers.each(function () {
                $(this).not(currentOpener).removeClass(activeClass);
            });

            var sel = $(this).attr("href");

            if(sel === showAll){
                $(this).addClass(activeClass);
                contents.addClass(activeClass);
                return;
            }

            if (!$(this).hasClass(activeClass)) {
                $(this).addClass(activeClass);
                contents.removeClass(activeClass).filter(sel).addClass(activeClass);
            }
            else {
                $(this).removeClass(activeClass);
                contents.removeClass(activeClass);
            }
        });
    });
};